export enum MobileOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  WINDOWS_PHONE = 'Windows Phone',
}

export const detectMobileOS = () => {
  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return MobileOS.WINDOWS_PHONE;
  }
  if (/android/i.test(userAgent)) {
    return MobileOS.ANDROID;
  }
  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return MobileOS.IOS;
  }
};
